import { Copy, Share2 } from 'lucide-react';
import { toast } from 'sonner';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { buildReferralLink, copyText, openWhatsAppShare } from '@/lib/referral';

export default function ReferralShareModal({
  open,
  onOpenChange,
  code,
  shareMessage = 'Join me on RESQLY for trusted home healthcare.',
}) {
  const link = buildReferralLink(code);

  const onCopyCode = async () => {
    await copyText(code);
    toast.success('Referral code copied');
  };

  const onCopyLink = async () => {
    await copyText(link);
    toast.success('Referral link copied');
  };

  const onWhatsApp = () => {
    openWhatsAppShare(shareMessage, link);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="referral-share-modal">
        <DialogHeader>
          <DialogTitle>Share RESQLY</DialogTitle>
          <DialogDescription>
            Invite friends and family. Referral is saved when they complete sign-up.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="rounded-lg bg-slate-50 p-3 text-center">
            <p className="text-xs text-slate-500 mb-1">Your code</p>
            <p className="text-lg font-semibold text-[var(--resqly-primary)] break-all">{code}</p>
          </div>
          <div className="flex flex-col gap-2">
            <Button variant="outline" onClick={onCopyCode} data-testid="modal-copy-code">
              <Copy className="w-4 h-4 mr-2" /> Copy code
            </Button>
            <Button variant="outline" onClick={onCopyLink} data-testid="modal-copy-link">
              <Copy className="w-4 h-4 mr-2" /> Copy link
            </Button>
            <Button onClick={onWhatsApp} data-testid="modal-share-whatsapp">
              <Share2 className="w-4 h-4 mr-2" /> Share on WhatsApp
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
